import List from "app/stores/list"
import { observable, action } from "mobx"
import request from 'app/vendor/request'
import config from 'app/config'

export default class Store {
  @observable list

  @action exportDataStep1 = () => {
    return request.post(`${config.backend}/array-pgt/result/statistics?${this.list.queryString}`)
      .query(this.list.processQueryMap)
      .checkToken()
      .commonDispose()
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, 'array-pgt/result/statistics')
    return store
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/arrayPgt/statistics.js